<div class="w-full mt-24">
  <auth-title [title]="title"> </auth-title>
  <auth-description [description]="description"></auth-description>
</div>
